import { createBatch, createEditor, createResource, JsonRestMiddleware } from 'redux-saga-resources';

import { authMiddleware } from '../auth/resource';
import { getDocumentId, noteServiceUserApi } from '../settings';
import { IAdmin } from '../types';
import { select, SelectEffect } from 'redux-saga/effects';
import { selectors as metaSelectors } from '../meta/selectors';

function* customUrls({ request, create, read, update, remove, list }: any, next: any) {
    if (create) {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        request.url = `${noteServiceUserApi}/admin`;
        request.params = {};
        request.body.documentId = selectionDocumentId;
    } else if (read) {
        request.url = `${noteServiceUserApi}/admin/${read.id}`;
        request.params = {};
    } else if (update) {
        request.url = `${noteServiceUserApi}/admin/${update.id}`;
        request.params = {};
    } else if (remove) {
        request.url = `${noteServiceUserApi}/admin/${remove.id}`;
        request.params = {};
    } else if (list) {
        if (list.documentId==null)
            request.url = `${noteServiceUserApi}/documents/${getDocumentId()}/admin`;
        else
            request.url = `${noteServiceUserApi}/documents/${list.documentId}/admin`;
        request.params = {};
    }
    yield* next();
}

const adminJsonMiddleware = JsonRestMiddleware(`${noteServiceUserApi}/documents/${getDocumentId()}/admin`, authMiddleware, customUrls);

export const beheerResource = createResource<IAdmin>('beheer', {}, adminJsonMiddleware);
export const beheerEditor = createEditor<IAdmin>('beheer', { createImmediately: false }, beheerResource);
export const beheerBatch = createBatch<IAdmin>('beheer', {}, beheerResource);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/admin/resource.tsx